// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-video-container {
  position: relative;
  width: 100vw;
  height: 90vh; /* 90% for laptop/desktop */
  overflow: hidden;
}

@media (max-width: 900px) {
  .home-video-container {
    height: 80vh; /* 80% for mobile/tablet */
  }
}

.home-bg-video {
  position: absolute;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  filter: brightness(1.2);
  z-index: 1;
}

.home-animated-text {
  position: absolute;
  left: 3vw;
  bottom: 5vh;
  z-index: 2;
  color: #fff;
  font-family: 'Montserrat', Arial, sans-serif;
  font-size: 4vw;
  font-weight: 900;
  letter-spacing: 1px;
  text-shadow: 0 4px 32px rgba(0,0,0,0.7);
  max-width: 90vw;
  transition: left 0.3s, bottom 0.3s, text-align 0.3s;
  display: flex;
  align-items: flex-end;
}

.home-fade-in {
  animation: fadeIn 1s;
  display: inline-block;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(40px);}
  to { opacity: 1; transform: translateY(0);}
}

@media (max-width: 900px) {
  .home-animated-text {
    font-size: 6vw;
    left: 50%;
    bottom: 5vh;
    transform: translateX(-50%);
    text-align: center;
    align-items: center;
    width: 90vw;
    justify-content: center;
  }
}

@media (max-width: 600px) {
  .home-animated-text {
    font-size: 8vw;
    left: 50%;
    bottom: 3vh;
    transform: translateX(-50%);
    text-align: center;
    align-items: center;
    width: 98vw;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY,EAAE,2BAA2B;EACzC,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY,EAAE,0BAA0B;EAC1C;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO;EACf,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,mDAAmD;EACnD,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,CAAC;EAC/C,KAAK,UAAU,EAAE,wBAAwB,CAAC;AAC5C;;AAEA;EACE;IACE,cAAc;IACd,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,cAAc;IACd,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[".home-video-container {\n  position: relative;\n  width: 100vw;\n  height: 90vh; /* 90% for laptop/desktop */\n  overflow: hidden;\n}\n\n@media (max-width: 900px) {\n  .home-video-container {\n    height: 80vh; /* 80% for mobile/tablet */\n  }\n}\n\n.home-bg-video {\n  position: absolute;\n  top: 0; left: 0;\n  width: 100vw;\n  height: 100vh;\n  object-fit: cover;\n  filter: brightness(1.2);\n  z-index: 1;\n}\n\n.home-animated-text {\n  position: absolute;\n  left: 3vw;\n  bottom: 5vh;\n  z-index: 2;\n  color: #fff;\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-size: 4vw;\n  font-weight: 900;\n  letter-spacing: 1px;\n  text-shadow: 0 4px 32px rgba(0,0,0,0.7);\n  max-width: 90vw;\n  transition: left 0.3s, bottom 0.3s, text-align 0.3s;\n  display: flex;\n  align-items: flex-end;\n}\n\n.home-fade-in {\n  animation: fadeIn 1s;\n  display: inline-block;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(40px);}\n  to { opacity: 1; transform: translateY(0);}\n}\n\n@media (max-width: 900px) {\n  .home-animated-text {\n    font-size: 6vw;\n    left: 50%;\n    bottom: 5vh;\n    transform: translateX(-50%);\n    text-align: center;\n    align-items: center;\n    width: 90vw;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 600px) {\n  .home-animated-text {\n    font-size: 8vw;\n    left: 50%;\n    bottom: 3vh;\n    transform: translateX(-50%);\n    text-align: center;\n    align-items: center;\n    width: 98vw;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
